/**
 * @generated SignedSource<<34321d0633bd1cb23b94548406d13054>>
 * @relayHash 5a90bd734b6a803ea4d3f84efc341d99
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4c602c004189d4479e8c29bb10b203be22b88bcfcec34b7005c88320e4868a4a

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useTeamTypeUserQuery$variables = {
  userId: string;
};
export type useTeamTypeUserQuery$data = {
  readonly user: {
    readonly __typename: string;
    readonly extendedProfile?: {
      readonly teamType: string | null | undefined;
    } | null | undefined;
    readonly id: string;
  } | null | undefined;
};
export type useTeamTypeUserQuery = {
  response: useTeamTypeUserQuery$data;
  variables: useTeamTypeUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "userId"
      }
    ],
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "concreteType": "AtlassianAccountUserExtendedProfile",
            "kind": "LinkedField",
            "name": "extendedProfile",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "teamType"
              }
            ]
          }
        ],
        "type": "AtlassianAccountUser"
      },
      {
        "kind": "ScalarField",
        "name": "id"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useTeamTypeUserQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTeamTypeUserQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5a90bd734b6a803ea4d3f84efc341d99",
    "id": "4c602c004189d4479e8c29bb10b203be22b88bcfcec34b7005c88320e4868a4a",
    "metadata": {},
    "name": "useTeamTypeUserQuery",
    "operationKind": "query",
    "text": "query useTeamTypeUserQuery($userId:ID!){user(accountId:$userId){__typename,...on AtlassianAccountUser{extendedProfile{teamType}},id}}"
  }
};
})();

(node as any).hash = "659b30ff95a73b6d22f7bc775f0941ef";

export default node;
